import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_SETSURVEY_FULFILLED = "FETCH_SETSURVEY_FULFILLED";
export const FETCH_SETSURVEY_REJECTED = "FETCH_SETSURVEY_REJECTED";
export const FETCH_SETSURVEY_PENDING = "FETCH_SETSURVEY_PENDING";
export const RESET = "RESET"

export function setSurvey(data) {
  const token = localStorage.getItem("accessToken")

  return (dispatch) => {
    dispatch({
      type: "FETCH_SETSURVEY",
      payload: axios({
        method: "post",
        url: `${API_BASE}/api/v2/second-opinion/survey`,
        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
        data: data,
      }).then((result) => result.data),
    });
  };
}

export function resetSetSurvey() {
  return (dispatch) => {
      dispatch({
          type: "RESET",
      });
  };
}




